import {
  AddRestoreAtlasPrivateLinkApi,
  type Configuration,
  GetMongoAtlasPrivateLinkApi,
  ListMongoAtlasPrivateLinksApi,
  type MongoAtlasPrivateLinkProvider,
  RemoveRestoreAtlasPrivateLinkApi,
  SetupMongoAtlasPrivateLinkApi,
  TeardownMongoAtlasPrivateLinkApi,
  VerifyMongoAtlasPrivateLinkApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/mongo-atlas-private-links';

export const mongoAtlasPrivateLinks = (
  httpClient: HttpClient,
  _config: Configuration,
  currentProjectId: string
) => {
  const config = _config;
  const listApi = new ListMongoAtlasPrivateLinksApi(config);
  const getApi = new GetMongoAtlasPrivateLinkApi(config);
  const setupApi = new SetupMongoAtlasPrivateLinkApi(config);
  const verifyApi = new VerifyMongoAtlasPrivateLinkApi(config);
  const teardownApi = new TeardownMongoAtlasPrivateLinkApi(config);
  const addExistingApi = new AddRestoreAtlasPrivateLinkApi(config);
  const removeRestoreApi = new RemoveRestoreAtlasPrivateLinkApi(config);

  return {
    useList: (cloudAccountId: string) =>
      httpClient.execute(
        listApi.listMongoAtlasPrivateLinks.bind(listApi),
        baseUrl,
        '/list',
        currentProjectId,
        cloudAccountId
      ),
    setup: (params: {
      cloudAccountId: string;
      region: string;
      serviceName: string;
      provider: MongoAtlasPrivateLinkProvider;
    }) =>
      setupApi.setupMongoAtlasPrivateLink(
        currentProjectId,
        params.cloudAccountId,
        {
          region: params.region,
          serviceName: params.serviceName,
          provider: params.provider,
        }
      ),
    get: (cloudAccountId: string, region: string) =>
      getApi.getMongoAtlasPrivateLink(currentProjectId, cloudAccountId, region),
    verify: (cloudAccountId: string, region: string) =>
      verifyApi.verifyMongoAtlasPrivateLink(
        currentProjectId,
        cloudAccountId,
        region
      ),
    teardown: (cloudAccountId: string, region: string) =>
      teardownApi.teardownMongoAtlasPrivateLink(
        currentProjectId,
        cloudAccountId,
        region
      ),
    addExisting: (params: {
      cloudAccountId: string;
      region: string;
      vpcEndpointId: string;
    }) =>
      addExistingApi.addRestoreAtlasPrivateLink(
        currentProjectId,
        params.cloudAccountId,
        {
          region: params.region,
          vpcEndpointId: params.vpcEndpointId,
        }
      ),
    removeRestore: (cloudAccountId: string, region: string) =>
      removeRestoreApi.removeRestoreAtlasPrivateLink(
        currentProjectId,
        cloudAccountId,
        region
      ),
  };
};
